export default __webpack_public_path__ + "static/media/no-match-found-bw.d7ef7497.png";